import {
  PRODUCT_MODEL_DATA_MEDIA_KEYS,
  PRODUCT_MODEL_KEY
} from 'models/daos/product/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  compactArrayUtil,
  pickObjectUtil
} from 'packages/src'

function getImagesProductUtil (instance) {
  return compactArrayUtil([
    getValueReduxUtil(instance, PRODUCT_MODEL_KEY.IMG),
    ...Object.values(
      pickObjectUtil(
        getValueReduxUtil(instance, PRODUCT_MODEL_KEY.DATA) || {},
        PRODUCT_MODEL_DATA_MEDIA_KEYS
      )
    )
  ])
}

export {
  getImagesProductUtil
}
